module.exports = __webpack_public_path__ + "NLSenaPage-image-on-topleft-500bca857fd0da209c9c.png";